<template>
  <div>
    <el-form-item label="产品价格：" width="80" :rules="[{ required: true, message: '请填写产品价格' }]">
      <template slot="label">
            <span>产品价格
              <el-tooltip class="item" effect="dark" placement="right">
                <i class="el-icon-question" style="font-size: 16px; vertical-align: middle;"></i>
                <div slot="content">
                  <p>按次收费，单次的价格</p>
                </div>
              </el-tooltip>
            </span>
      </template>
      <el-input type="number" v-model="form.productPrice" class="max-w460"></el-input>
    </el-form-item>
  </div>
</template>

<script>
export default {
  props: {
    model: {
      type: Object,
      default: {}
    },
  },
  data() {
    return {
      form: {}
    }
  },
  watch: {
    'model': {
      handler(values, oldVal) {
        this.form = values
      },
      immediate: true,
      deep: true
    },
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/product/product/part/priceStage/Fixed.vue